(function () {
  function getSizingApi() {
    return window.FourPawLibertySizing || null;
  }

  function getLeashDescription(value) {
    const normalized = String(value || '').toLowerCase();

    if (normalized.includes('bungee')) {
      return 'סופגת עומס קטן בדרך ומרגישה בטוחה יותר עם כלבים אנרגטיים.';
    }

    if (normalized.includes('rope')) {
      return 'תחושה קלה וגמישה ביד, עם מראה קצת יותר נקי ומינימלי.';
    }

    if (normalized.includes('classic')) {
      return 'בחירה יומיומית נקייה ומדויקת, עם שליטה פשוטה בלי להסתבך.';
    }

    return 'בחרו את סגנון הרצועה שמתאים לאיך שאתם אוהבים לטייל ביום יום.';
  }

  function getVariantSelectRoot() {
    return document.querySelector('variant-selects[id^="variant-selects-"]');
  }

  function getVariantsData(variantRoot) {
    if (!variantRoot) return [];
    const jsonNode = variantRoot.querySelector('script[type="application/json"]');
    if (!jsonNode) return [];

    try {
      return JSON.parse(jsonNode.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getSelectedVariant(variantRoot) {
    if (!variantRoot) return null;
    const variants = getVariantsData(variantRoot);
    if (!variants.length) return null;

    const optionInputs = Array.from(variantRoot.querySelectorAll('.product-form__input'));
    const selectedValues = optionInputs
      .filter((group) => !group.classList.contains('hidden'))
      .map((group) => {
        const checked = group.querySelector('input:checked');
        if (checked) return checked.value;
        const select = group.querySelector('select');
        if (select) return select.value;
        return null;
      })
      .filter((value) => value != null && value !== '');

    return variants.find((variant) =>
      Array.isArray(variant.options) &&
      selectedValues.every((value, index) => variant.options[index] === value)
    ) || null;
  }

  function isColorSpecificAlt(value) {
    if (!value) return false;
    return /^https:\/\/cdn\.shopify\.com\/.*Harness\.png/i.test(String(value));
  }

  function syncGalleryVisibility() {
    const variantRoot = getVariantSelectRoot();
    const selectedVariant = getSelectedVariant(variantRoot);
    const activeAlt =
      selectedVariant &&
      selectedVariant.featured_media &&
      selectedVariant.featured_media.alt
        ? String(selectedVariant.featured_media.alt)
        : '';

    if (!activeAlt) return;

    const mediaItems = Array.from(document.querySelectorAll('.main-product--liberty-kit .product__media-item[data-alt]'));
    const thumbnailItems = Array.from(document.querySelectorAll('.main-product--liberty-kit .thumbnail-list__item[data-alt]'));
    const dotLinks = Array.from(document.querySelectorAll('.main-product--liberty-kit .slider-counter__link[data-alt]'));

    const applyVisibility = (node) => {
      const alt = node.dataset.alt || '';
      const keepVisible = !isColorSpecificAlt(alt) || alt === activeAlt || alt === 'always_display';
      node.classList.toggle('hidden', !keepVisible);
      return keepVisible;
    };

    mediaItems.forEach(applyVisibility);
    thumbnailItems.forEach(applyVisibility);
    dotLinks.forEach(applyVisibility);

    const activeMedia = document.querySelector('.main-product--liberty-kit .product__media-item.is-active');
    if (activeMedia && activeMedia.classList.contains('hidden')) {
      const fallbackVisible = mediaItems.find((item) => !item.classList.contains('hidden'));
      if (fallbackVisible) {
        activeMedia.classList.remove('is-active');
        fallbackVisible.classList.add('is-active');
      }
    }
  }

  function syncLeashPicker(root) {
    const optionName = root.dataset.optionName;
    const propertyInput = root.querySelector('[data-liberty-kit-leash-property]');
    const cards = Array.from(root.querySelectorAll('.liberty-kit-leash-card'));
    if (!cards.length) return;

    if (!optionName) {
      if (!propertyInput) return;

      function applyFallbackState() {
        cards.forEach((card) => {
          const isActive = propertyInput.value === card.dataset.value;
          card.classList.toggle('is-active', isActive);
          card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          card.disabled = false;
        });
      }

      cards.forEach((card) => {
        const description = card.querySelector('.liberty-kit-leash-card__text');
        if (description && !description.textContent.trim()) {
          description.textContent = getLeashDescription(card.dataset.value);
        }

        card.addEventListener('click', () => {
          propertyInput.value = card.dataset.value;
          applyFallbackState();
        });
      });

      applyFallbackState();
      return;
    }

    const section = root.closest('[data-section]');
    if (!section) return;

    const inputSelector = `variant-selects input[name="${CSS.escape(optionName)}"]`;
    const inputs = Array.from(section.querySelectorAll(inputSelector));
    if (!inputs.length) {
      return;
    }

    function applyState() {
      const active = inputs.find((input) => input.checked);
      cards.forEach((card) => {
        const isActive = active && active.value === card.dataset.value;
        card.classList.toggle('is-active', Boolean(isActive));
        card.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        const input = inputs.find((item) => item.value === card.dataset.value);
        const isDisabled = !input || input.disabled || input.classList.contains('non-existent');
        card.disabled = isDisabled;
      });
    }

    cards.forEach((card) => {
      const description = card.querySelector('.liberty-kit-leash-card__text');
      if (description && !description.textContent.trim()) {
        description.textContent = getLeashDescription(card.dataset.value);
      }

      card.addEventListener('click', () => {
        const input = inputs.find((item) => item.value === card.dataset.value);
        if (!input || input.disabled) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        applyState();
      });
    });

    inputs.forEach((input) => {
      input.addEventListener('change', applyState);
    });

    applyState();
  }

  function closeLibertySizeModal(modal, openedBy) {
    if (!modal || !modal.hasAttribute('open')) return;

    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    modal.removeAttribute('open');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(openedBy || null);
    }

    if (typeof window.pauseAllMedia === 'function') {
      window.pauseAllMedia();
    }
  }

  function setupLibertySizeModalClose(modal, openedBy) {
    if (!modal || modal.dataset.libertySizeCloseReady === 'true') return;

    modal.dataset.libertySizeCloseReady = 'true';

    const closeButton = modal.querySelector('.product-popup-modal__toggle');
    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeLibertySizeModal(modal, openedBy);
      });
    }

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeLibertySizeModal(modal, openedBy);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.hasAttribute('open')) {
        closeLibertySizeModal(modal, openedBy);
      }
    });
  }

  function setupCalculator(root) {
    const sizing = getSizingApi();
    if (!sizing) return;

    const opener = root.querySelector('modal-opener[data-modal]');
    const openerButton = opener ? opener.querySelector('button') : null;
    const modalSelector = opener ? opener.getAttribute('data-modal') : '';
    const modal = modalSelector ? document.querySelector(modalSelector) : null;
    const scope = modal || root.closest('[data-section]') || document;

    setupLibertySizeModalClose(modal, openerButton);

    if (scope.dataset && scope.dataset.libertySizeCalculatorReady === 'true') return;

    const breedSelect = scope.querySelector('[data-liberty-size-breed]');
    const weightInput = scope.querySelector('[data-liberty-size-weight]');
    const submitButton = scope.querySelector('[data-liberty-size-submit]');
    const resultBox = scope.querySelector('[data-liberty-size-result]');
    const sizeBadge = scope.querySelector('[data-liberty-size-badge]');
    const summary = scope.querySelector('[data-liberty-size-summary]');
    const notes = scope.querySelector('[data-liberty-size-notes]');
    const ranges = scope.querySelector('[data-liberty-size-ranges]');

    if (!breedSelect || !weightInput || !submitButton || !resultBox) return;
    if (scope.dataset) scope.dataset.libertySizeCalculatorReady = 'true';

    if (!breedSelect.options.length || breedSelect.options.length === 1) {
      sizing.BREED_OPTIONS.forEach((breed) => {
        const option = document.createElement('option');
        option.value = breed;
        option.textContent = breed;
        breedSelect.appendChild(option);
      });
    }

    if (ranges && !ranges.childElementCount) {
      sizing.SIZE_ORDER.forEach((size) => {
        const range = sizing.LIBERTY_SIZE_RANGES[size];
        const item = document.createElement('div');
        item.className = 'liberty-kit-size-modal__range';
        const weightText = size === 'XL' ? `${range.weightMin}-${range.weightMax} ק\"ג` : `${range.weightMin}-${range.weightMax} ק\"ג`;
        item.innerHTML = `<strong>${size}</strong><div>${weightText}</div><div>${range.bustMin}-${range.bustMax} ס\"מ חזה</div>`;
        ranges.appendChild(item);
      });
    }

    submitButton.addEventListener('click', () => {
      const breed = breedSelect.value;
      const weightKg = Number(weightInput.value);
      const result = sizing.calculateLibertySizeRecommendation({ breed, weightKg });

      sizeBadge.textContent = result.recommendedSize;
      resultBox.dataset.fitState = result.fitState || 'neutral';

      const headlineParts = [];
      if (result.breed) {
        headlineParts.push(`לפי ${result.breed}`);
      }
      if (Number.isFinite(result.weightKg) && result.weightKg > 0) {
        headlineParts.push(`${result.weightKg} ק"ג`);
      }

      summary.textContent = headlineParts.length
        ? `${result.fitLabel || 'ההמלצה שלנו'}: ${result.recommendedSize} · ${headlineParts.join(' · ')}`
        : `${result.fitLabel || 'ההמלצה שלנו'}: ${result.recommendedSize}`;

      notes.innerHTML = '';
      result.notes.forEach((note) => {
        const li = document.createElement('li');
        li.textContent = note;
        notes.appendChild(li);
      });

      resultBox.classList.add('is-visible');
    });
  }

  function initLibertyKitPdp() {
    document.body.classList.add('liberty-kit-page');
    document.querySelectorAll('[data-liberty-kit-size-tools]').forEach(setupCalculator);

    const variantRoot = getVariantSelectRoot();
    if (variantRoot) {
      const applyGallery = () => window.requestAnimationFrame(syncGalleryVisibility);
      variantRoot.addEventListener('change', applyGallery);
      variantRoot.addEventListener('input', applyGallery);
      applyGallery();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLibertyKitPdp);
  } else {
    initLibertyKitPdp();
  }
})();
